// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_na-2";
export var interactiveWrapper = "_na-0";
export var shippingHoverPreview = "_na-4";
export var summaryBadgeTrigger = "_na-1";
export var widgetHoverPreviewList = "_na-3";
export var widgetPreviewScale = "_na-5";